import React from 'react';
import { Box, Grid } from '@mui/material';
import { HelpTip, Card, Typography, Switch } from '@occc-app/design-system';

import { CommunicationPreferenceMapItem } from './communication-preferences.types';
import { getOptedInOutText } from './communication-preferences.utils';

type CommunicationPreferenceItemProps = {
  item: CommunicationPreferenceMapItem;
  subBrandUuid: string | null | undefined;
  isUSPhoneNumber: boolean;
  updateInProgress: boolean;
  isUserPermittedToEdit: boolean;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    preferenceName: string,
    subBrandUuid?: string | null,
  ) => void;
};

export const CommunicationPreferenceItem = ({
  item,
  subBrandUuid,
  isUSPhoneNumber,
  updateInProgress,
  isUserPermittedToEdit,
  onChange,
}: CommunicationPreferenceItemProps) => {
  if (!item.isEnabled) {
    return null;
  }

  if (item.name === 'smsOpt' && !isUSPhoneNumber) {
    return (
      <Grid item xs={12}>
        <Card elevation={0}>
          <HelpTip title='SMS communication preference supports only US phone numbers' />
        </Card>
      </Grid>
    );
  }

  const isSwitchDisabled = updateInProgress || !isUserPermittedToEdit;

  return (
    <Grid item xs={12} md={4}>
      <Box sx={{ display: 'flex', alignItems: 'start', gap: 1 }}>
        <Switch
          name={item.name}
          checked={item.optIn}
          onChange={(e) => onChange(e, item.name, subBrandUuid)}
          disabled={isSwitchDisabled}
        />
        <Box>
          <Typography variant='subtitle2'>{item.title}</Typography>
          <Typography variant='body2' color='textSecondary'>
            {getOptedInOutText(item)}
          </Typography>
        </Box>
      </Box>
    </Grid>
  );
};
